export default "__VITE_ASSET__BqiN8Oma__"